const REM_FACTOR = 1 / 12;
export const sr = (value: number): string => `${value * REM_FACTOR}rem`;
export const r = (...values: number[]): string => values.map(sr).join(" ");
